/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $AcceptUserTermsRequest = {
  properties: {
    terms: {
      type: 'array',
      contains: {
        type: 'Term',
      },
      isRequired: true,
    },
  },
} as const;
